import React, { useEffect, useState } from 'react';
import axios from 'axios';
import TablaSolicitudesMedicos from './TablaSolicitudesMedicos';
import TablaSuscripciones from './TablaSuscripciones';
import DatosPlayeras from './DatosPlayeras';
import MonitoreoDoctores from './MonitoreoDoctores';  // Importa el componente

export default function DashboardAdmin() {
  const [selectedSection, setSelectedSection] = useState('solicitudes');

  return (
    <div className="flex h-full min-h-screen bg-gray-100 m-6 rounded-2xl shadow-2xl">
      {/* Menú lateral */}
      <aside className="w-64 bg-white border-r p-6">
        <h2 className="text-xl font-bold mb-6">Menú Admin</h2>
        <nav className="flex flex-col space-y-2">
          {['solicitudes', 'doctores', 'suscripciones', 'playeras'].map((section) => (
            <button
              key={section}
              onClick={() => setSelectedSection(section)}
              className={`text-left px-4 py-2 rounded ${
                selectedSection === section ? 'bg-blue-500 text-white' : 'hover:bg-gray-200'
              }`}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </button>
          ))}
        </nav>
      </aside>

      {/* Contenido principal */}
      <main className="flex-grow p-8">
        {selectedSection === 'solicitudes' && <TablaSolicitudesMedicos />}
        {selectedSection === 'doctores' && <MonitoreoDoctores />}
        {selectedSection === 'suscripciones' && <TablaSuscripciones />}
        {selectedSection === 'playeras' && <DatosPlayeras />}
      </main>
    </div>
  );
}
